export enum ReportsRoutePathNames {
  REPORTS = 'reports',
  DISCOUNTS = 'discounts',
  SALES_SUMMARY = 'sales-summary',
  SALES_DISTRIBUTION = 'sales-distribution',
  SALES_MIX = 'sales-mix',
  REFUND = 'refund-reports',
  TERMINAL_SALES = 'terminal-sales',
  SALES_READINGS = 'sales-reading',
  REPORTING_DIAGNOSTICS = 'reporting-diagnostics',
}
